
import WDCard, { WDCardHeader } from './wd-card';
import WDButton from '../button/wd-button';
import WDElementCollapsible from '../wd-element-collapsible';

export default class WDAccordionCard extends WDCard
{

	#options;
	#wrapper = null;
	#header = null;
	
	constructor(opts)
	{
		const cardOptions = { collapsed: false };
		Object.assign(cardOptions, opts);

		super(cardOptions).classList.add('wd-accordion-card');

		this.#options = cardOptions;
	};

	connectedCallback()
	{
		super.connectedCallback();

		this.header;
		this.wrapper;

		if (!this.#options?.collapsed) 
		{
			this.classList.add('is-open');
			this.open();
		}
	};

	get header()
	{
		if (!this.#header) 
		{
			this.#header = new WDAccordionCardHeader();
			this.body.before(this.#header);
		}
		return this.#header;
	};

	get wrapper()
	{
		if (!this.#wrapper)
		{
			this.#wrapper = new WDElementCollapsible();
	
			//put the wrapper before the body, then move the body inside the wrapper
			this.body.before(this.#wrapper);
			this.#wrapper.append(this.body);
	
			this.#wrapper.on('element:open', () => this.classList.add('is-open'));
			this.#wrapper.on('element:close', () => this.classList.remove('is-open'))

			if (this.#options.collapsed) this.#wrapper.close();	

		}

		return this.#wrapper;
	};

	/** card visibility **/
	open()
	{
		this.wrapper.open();
	};

	close()
	{
		this.wrapper.close();
	};

	toggle() 
	{
		this.wrapper.toggle();
	};

};

export class WDAccordionCardHeader extends WDCardHeader
{

	#toggleButton = null;

	constructor(cfg)
	{
		super(cfg).classList.add('wd-card-header');
	};

	connectedCallback()
	{
		super.connectedCallback();

		const config = this.closest('.wd-card').config;
		this.toggleButton.label = config.title;
	};

	get toggleButton()
	{
		if (!this.#toggleButton)
		{
			this.#toggleButton = new WDButton({ fasIcon: 'chevron-right', click: (evt) => this.closest('.wd-card').toggle(evt) });
			this.prepend(this.#toggleButton);
		}

		return this.#toggleButton;
	};

};

customElements.define('wd-accordion-card', WDAccordionCard);
customElements.define('wd-accordion-card-header', WDAccordionCardHeader);
